// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zgVY9AFG1Asd6V9SCErs{align-items:center;display:flex}.u5ViQ22CWG841MM1VGUL .FesQBMDUuYflX384ihaT{margin-left:6px}.qZkHIi0rndcByok3BCSj{color:var(--black-30);margin-right:8px}.FesQBMDUuYflX384ihaT{color:var(--content-primary-primary);max-width:150px}.qsdMGpeiwc5wW3IMHGee{color:var(--black-30);margin-left:8px}.GMtBXmrTC1w6dtSwgS_E{background:var(--background-brand-subtle-primary);color:var(--content-primary-tertiary)}.gd5b665jTegcksZit9hm{color:var(--content-primary-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `zgVY9AFG1Asd6V9SCErs`,
	"wrap--checkbox": `u5ViQ22CWG841MM1VGUL`,
	"wrapCheckbox": `u5ViQ22CWG841MM1VGUL`,
	"title": `FesQBMDUuYflX384ihaT`,
	"icon": `qZkHIi0rndcByok3BCSj`,
	"count": `qsdMGpeiwc5wW3IMHGee`,
	"highlighter": `GMtBXmrTC1w6dtSwgS_E`,
	"highlighter--label": `gd5b665jTegcksZit9hm`,
	"highlighterLabel": `gd5b665jTegcksZit9hm`
};
export default ___CSS_LOADER_EXPORT___;
